<template>
    <div class="backgroundWrapper agency-bg">
        <div class="listToggle">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <div class="nav-link" :class="{ active: activeTab === 'thisweek' }"
                        @click="activateTab('thisweek')">
                        This Week
                    </div>
                </li>

                <li class="nav-item">
                    <div class="nav-link" :class="{ active: activeTab === 'lastweek' }"
                        @click="activateTab('lastweek')">
                        Last Week
                    </div>
                </li>
            </ul>

            <!-- ✅ TimesBox -->
            <div class="timesBox" v-show="isTimesBoxVisible">
                <CounterdownCompo :isVisible="true" :showDays="true" />
            </div>
        </div>
        <!-- ✅ TAB CONTENT -->
        <div class="tab-content">
            <div class="tab-contentIn">
                <KeepAlive>
                    <component :is="currentComponent" />
                </KeepAlive>
            </div>
        </div>

        <!-- <div class="tab-content">
            <div class="tab-pane" :class="{ 'active': activeTab === 'thisweek' }" id="thisweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedThisWeek">
                    <AgencyThisWeekTabCont />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'lastweek' }" id="lastweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedLastWeek">
                    <AgencyLastWeekTabCont />
                </div>
            </div>
        </div> -->

    </div>
</template>
<script>
import { defineAsyncComponent } from "vue";
import CounterdownCompo from "../CounterdownCompo.vue";
import LoadingOverlay from "../LoadingOverlay.vue";
export default {
    name: "AgencyCompTab",

    components: {
        CounterdownCompo,

        // ✅ Async import (fast initial load)
        AgencyThisWeekTabCont: defineAsyncComponent({
            loader: () => import("./AgencyThisWeekTabCont.vue"),
            loadingComponent: LoadingOverlay,
            delay: 100,
        }),

        AgencyLastWeekTabCont: defineAsyncComponent({
            loader: () => import("./AgencyLastWeekTabCont.vue"),
            loadingComponent: LoadingOverlay,
            delay: 100,
        }),
    },

    data() {
        return {
            activeTab: "thisweek",
            isTimesBoxVisible: true,
        };
    },

    computed: {
        // ✅ Dynamic component selection
        currentComponent() {
            return this.activeTab === "thisweek"
                ? "AgencyThisWeekTabCont"
                : "AgencyLastWeekTabCont";
        },
    },

    mounted() {
        // ✅ Prefetch last week in background for instant switching (optional)
        setTimeout(() => {
            import("./AgencyLastWeekTabCont.vue");
        }, 1000);
    },

    methods: {
        activateTab(tabId) {
            this.activeTab = tabId;

            // ✅ TimesBox logic
            this.isTimesBoxVisible = tabId === "thisweek";
        },
    },
};
</script>